// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__kKlyA","social":"socials__social__u_of1","icon":"socials__icon__ZvNqF","navOpen":"socials__navOpen__Q1lW9"};